import React from "react";
import logo2 from "../../img/logo2.png";
import { Link } from "react-router-dom";
import login from "../../img/figure/login.jpg";
const Login = () => {
  return (
    <div
      className="login-page-wrap"
      style={{
        backgroundImage: `url(${login})`,
      }}
    >
      <div className="login-page-content">
        <div className="login-box">
          <div className="item-logo">
            <img src={logo2} alt="logo" />
          </div>
          <form action="index.html" className="login-form">
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                placeholder="Enter usrename"
                className="form-control"
              />
              <i className="far fa-envelope" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="text"
                placeholder="Enter password"
                className="form-control"
              />
              <i className="fas fa-lock" />
            </div>
            <div className="form-group d-flex align-items-center justify-content-between">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="remember-me"
                />
                <label htmlFor="remember-me" className="form-check-label">
                  Remember Me
                </label>
              </div>
              <a href="#" className="forgot-btn">
                Forgot Password?
              </a>
            </div>
            <div className="form-group">
              <Link to="/admin" type="submit" className="login-btn">
                Login
              </Link>
            </div>
          </form>
          <div className="login-social">
            <p>or sign in with</p>
            <ul>
              <li>
                <a href="#" className="bg-fb">
                  <i className="fab fa-facebook-f" />
                </a>
              </li>
              <li>
                <a href="#" className="bg-twitter">
                  <i className="fab fa-twitter" />
                </a>
              </li>
              <li>
                <a href="#" className="bg-gplus">
                  <i className="fab fa-google-plus-g" />
                </a>
              </li>
              <li>
                <a href="#" className="bg-git">
                  <i className="fab fa-github" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="sign-up">
          Don't have an account ? <a href="#">Signup now!</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
